import React, { useState } from "react";
import { ReactComponent as VideoBtn } from "../../../assets/videoBtn.svg";
import videoImg from "../../../assets/aeroplantwo.png";

const HowWorksClaim = () => {
  const [videoplay, setvideoplay] = useState(false);
  return (
    // <div className="container-wrapper">
    //     <div
    //       style={{
    //         display: "flex",
    //         justifyContent: "space-between",
    //         gap: "32px",
    //       }}
    //     >
    //       <h1 className="header">Watch how Fly n’ Claim works</h1>
    //       <p>
    //         In under 60 seconds, learn how we simplify the claim process and
    //         secure your compensation.
    //       </p>
    //     </div>

    //     <div
    //       style={{ width: "100%", margin: "40px auto", position: "relative" }}
    //     >
    //       {/* <img src={videoImg} className="img-full" /> */}

    //       {!videoplay && (
    //   <VideoBtn
    //     className="absolute-center"
    //     style={{ cursor: "pointer" }}
    //   />
    // )}
    // <video
    //   src="https://db.seventhsight.com/storage/v1/object/sign/flyandclaim/Comp%201_2.mp4?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJmbHlhbmRjbGFpbS9Db21wIDFfMi5tcDQiLCJpYXQiOjE3NDE0Mzk5OTQsImV4cCI6MjYwNTQzOTk5NH0.j1PR8oepniOJ6bltw-sd-fzq-tR0MU5PQfjavSq95oc"
    //   className="img-full"
    //   poster={videoImg}
    //   controls
    //   onPlay={() => setvideoplay(true)}
    //   onPause={() => setvideoplay(false)}
    // ></video>

    //     </div>
    //   </div>
    <></>
  );
};

export default HowWorksClaim;
